// extracted by mini-css-extract-plugin
export default {"inputContainer":"input_inputContainer__Sjw1F","inputLabel":"input_inputLabel__JQ+tL"};